import { gql } from "@apollo/client";

export const GET_ARCHIVO_DOCUMENTO_ASISTENCIAL = gql`
query archivoDocumentoAsistencial(
    $idArchivo: Int!,
    $idTipoArchivoDocumento: Int!) {
    archivoDocumentoAsistencial(
        idArchivo: $idArchivo,
        idTipoArchivoDocumento: $idTipoArchivoDocumento) {
        success
        error
        valorEsperado{
            archivo,
            titulo,
            extension,
            contentType,
            fechaAlta,
        }
    }
}
 `;

export const adaptDocumentoById = (documento) => ({
  contentType: documento?.archivoDocumentoAsistencial?.valorEsperado?.contentType,
  titulo: documento?.archivoDocumentoAsistencial?.valorEsperado?.titulo,
  archivo: documento?.archivoDocumentoAsistencial?.valorEsperado?.archivo,
  extension: documento?.archivoDocumentoAsistencial?.valorEsperado?.extension
});